// eslint-disable-next-line import/prefer-default-export
export enum NahlasenieChybyEnum {
  EZBIERKA = 'eZbierka',
  ELEGISLATIVA = 'eLegislatíva',
  VYKONAVACIE_PREDPISY = 'Vykonávacie predpisy',
  TEZAURY = 'Tezaury',
  PRAVO_EU = 'Právo EÚ',
  JUDIKATY = 'Judikáty',
  REGISTRACIA = 'Registrácia',
  INE = 'Iné',
}
